import { render, staticRenderFns } from "./CloseAccountModal.vue?vue&type=template&id=08576ffc"
import script from "./CloseAccountModal.vue?vue&type=script&lang=js"
export * from "./CloseAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports